export default {
    computed: {
        currentStepNumber() {
            return this.$route.meta.stepNumber;
        },
        simSteps() {
            return this.steps;
        },
        currentStepTitle() {
            return this.simSteps[this.currentStepNumber]?.title + this.$i18nApi.t(this.simSteps[this.currentStepNumber]?.translationString);
        },
        sortedStepKeys() {
            const stepKeys = Object.keys(this.simSteps);
            return this.sortSteps(stepKeys);
        },        
        pastSteps() {
            const sortedKeys = this.sortedStepKeys;
            const currentIndex = sortedKeys.indexOf(this.currentStepNumber);
            return sortedKeys.slice(0, currentIndex);
        },
        futureSteps() {
            const sortedKeys = this.sortedStepKeys;
            const currentIndex = sortedKeys.indexOf(this.currentStepNumber);
            return sortedKeys.slice(currentIndex + 1);
        },
    },
    methods: {
        sortSteps(keys) {
            return keys.sort((a, b) => {
                // Extract the numeric part of the step keys
                const numA = parseInt(a, 10);
                const numB = parseInt(b, 10);

                return numA - numB;
            });
        },

        isDirectlyPreviousStep(step) {
            const sortedKeys = this.sortedStepKeys;
            const currentIndex = sortedKeys.indexOf(this.currentStepNumber);
            const previousIndex = currentIndex - 1;
            return sortedKeys[previousIndex] === step;
        },
    },
};